import { Button, Flex, Text, Title } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import defaultImageSrc from '@/assets/images/document.png';
import { useDevices } from '@/utils/devices';

import s from './EmptyStubContent.module.scss';

type EmptyStubContentProps = {
  className?: string;
  title: string;
  text: string;
  imageSrc?: string;
  imageAlt?: string;
  actionLabel?: string;
  onActionClick?: () => void;
};

const EmptyStubContent: React.FC<EmptyStubContentProps> = ({
  className,
  title,
  text,
  imageSrc,
  imageAlt,
  actionLabel,
  onActionClick,
}) => {
  const { isCompactViewport } = useDevices();

  return (
    <div className={cn(s.root, className)}>
      <Flex className={s.root__content} align="center" direction="column" gap="xs">
        <Flex align="center" direction="column" gap="sm">
          <img
            src={imageSrc ?? defaultImageSrc}
            alt={imageAlt ?? ''}
            width={isCompactViewport ? 80 : 130}
            height={isCompactViewport ? 80 : 130}
            className={s.root__image}
          />
          <Title size={isCompactViewport ? 'h3' : 'h2'}>{title}</Title>
        </Flex>
        <Text size={isCompactViewport ? 'sm' : 'md'} c="dimmed">
          {text}
        </Text>
        {actionLabel && (
          <Button size={isCompactViewport ? 'xs' : 'sm'} onClick={onActionClick}>
            {actionLabel}
          </Button>
        )}
      </Flex>
    </div>
  );
};

export default React.memo(EmptyStubContent);
